import type { ReactElement } from 'react';

import classNames from 'classnames';

import VARIANTS, { type VariantType } from '../../constants/variants';
import type { IconType } from '../../icons/constants';
import Icon from '../../icons/icon';
import type { FCC } from '../../types/common';
import IconButton from '../icon_button/icon_button';

import styles from './alert.module.css';

type Props = {
  className?: string;
  bodyClassName?: string;
  variant?: VariantType;
  icon?: IconType;
  actionIcon?: IconType;
  title?: string | ReactElement;
  size?: 'small' | 'big';
  onActionClick?: () => void;
};

const Alert: FCC<Props> = (props) => {
  const {
    className,
    bodyClassName,
    variant = VARIANTS.INFO,
    icon,
    title,
    size,
    children,
    actionIcon,
  } = props;

  const bodyIcon = icon ? (
    <div className={styles.body_icon_wrapper}>
      <Icon size={20} icon={icon} />
    </div>
  ) : null;

  const iconForAction = actionIcon ? (
    <IconButton
      uiKey="action-handler-button"
      icon={actionIcon}
      className={styles.action_button}
      variant="banner"
      onClick={props.onActionClick}
    />
  ) : null;

  const alertHeader = title ? <h3 className={styles.title}>{title}</h3> : null;

  const alertBody = children ? (
    <div
      className={classNames(
        title ? styles.alert_body_with_header : styles.alert_body,
        bodyClassName,
      )}
    >
      {children}
    </div>
  ) : null;

  return (
    <div
      role="alert"
      className={classNames(
        className,
        styles.root,
        styles[variant],
        styles[size || 'big'],
      )}
    >
      <div className={styles.alert_content}>
        {bodyIcon}
        <div className={styles.content_group}>
          {alertHeader}
          {alertBody}
        </div>
      </div>
      {iconForAction}
    </div>
  );
};

export default Alert;
